import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/actions/index';
import ProjectModal from './ProjectModal';

const CloneProjectModal = (props) => {

  const dispatch = useDispatch();

  let project = {};
  const projectId = props.formObject.id;
  const onSubmitAction = (values) => {
    return actions.cloneProject(values, projectId)
  };

  useEffect(() => { dispatch( actions.initProject(projectId)) }, []);

  const loading = useSelector(state => state.inventory.loading_project );
  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  const modalTitle = "Projekt kopieren";



  if ( (!loading || project !== {}) && projectId !== undefined) {
    project = thisProject(projectId) || {};

    const initialValues = {
        title: project.title || '',
        building: project.building || '',
        street: project.street || '',
        zipcode: project.zipcode || '',
        city: project.city || '',

        contact_name: project.contact_name || '',
        contact_company: project.contact_company || '',
        contact_email: project.contact_email || '',
        contact_phone: project.contact_phone || '',

        customer_name: project.customer_name || '',
        customer_company: project.customer_company || '',
        customer_street: project.customer_street || '',
        customer_zipcode: project.customer_zipcode || '',
        customer_phone: project.customer_phone || '',
        customer_country: project.customer_country || '',
        customer_email: project.customer_email || '',
      };

    return (

      <ProjectModal
        modalTitle={modalTitle}
        onSubmitAction={onSubmitAction}
        initialValues={initialValues}
      />)

  } else {
    return null;
  }


}

export default CloneProjectModal



// WEBPACK FOOTER //
// ./src/components/Modals/CloneProjectModal.js